<div class="form-card">
  <div class="card-header">
    <div class="card-header-icon vendas-icon">
      <i class="pi pi-chart-bar"></i>
    </div>
    <span class="card-header-title">{{ 'relatorio-vendas.headers.relatorio_de_vendas' | translate }}</span>
  </div>
  <div class="card-content">
    <div class="form-grid">

      <!-- SELECIONAR NOTA -->
      <div class="form-field full">
        <label class="form-label">{{ 'relatorio-vendas.labels.selecionar_nota' | translate }}</label>
        <p-dropdown [options]="notas" [(ngModel)]="selectedNota" optionLabel="emissao"
          [filter]="true" [filterBy]="'emissao'" [showClear]="true"
          [placeholder]="('relatorio-vendas.labels.selecionar_nota' | translate)" (onFilter)="onNotasFilter($event)"
          [loading]="loadingNotas" styleClass="w-full" panelStyleClass="notas-dropdown-panel" appendTo="body">

          <ng-template pTemplate="header">
            <div class="grid font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="col-2">{{ 'relatorio-vendas.table_headers.codigo_da_nota' | translate }}</div>
              <div class="col-2">{{ 'relatorio-vendas.table_headers.emissao' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-nota pTemplate="item">
            <div class="grid px-2 py-1 text-sm">
              <div class="col-2">{{ nota.codigoNota }}</div>
              <div class="col-2">{{ formatarDataEHora(nota.emissao) }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="selectedItem" let-nota>
            {{ nota.codigoNota + ' - ' + formatarDataEHora(nota.emissao) }}
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-vendas.labels.nenhum_cliente_encontrado' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- SELECIONAR CLIENTE -->
      <div class="form-field full">
        <label class="form-label">{{ 'relatorio-vendas.labels.selecionar_cliente' | translate }}</label>
        <p-dropdown [options]="clientes" [(ngModel)]="selectedCliente" optionLabel="nome"
          [filter]="true" [filterBy]="'nome,fantasia,telefone,ci,ruc,nomeCidade,codigoPessoa'" [showClear]="true"
          [placeholder]="('relatorio-vendas.labels.selecionar_cliente' | translate)" (onFilter)="onClientesFilter($event)"
          [loading]="loadingClientes" styleClass="w-full" appendTo="body">

          <ng-template pTemplate="header">
            <div class="grid font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="col-2">{{ 'relatorio-vendas.table_headers.codigo' | translate }}</div>
              <div class="col-2">{{ 'relatorio-vendas.table_headers.nome' | translate }}</div>
              <div class="col-2">{{ 'relatorio-vendas.table_headers.nome_fantasia' | translate }}</div>
              <div class="col-2">{{ 'relatorio-vendas.table_headers.telefone' | translate }}</div>
              <div class="col-2">{{ 'relatorio-vendas.table_headers.ci' | translate }}</div>
              <div class="col-2">{{ 'relatorio-vendas.table_headers.ruc' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-cliente pTemplate="item">
            <div class="grid px-2 py-1 text-sm">
              <div class="col-2">{{ cliente.codigoPessoa }}</div>
              <div class="col-2">{{ cliente.nome }}</div>
              <div class="col-2">{{ cliente.fantasia }}</div>
              <div class="col-2">{{ cliente.telefone }}</div>
              <div class="col-2">{{ cliente.ci }}</div>
              <div class="col-2">{{ cliente.ruc }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-vendas.labels.nenhum_cliente_encontrado' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- SELECIONAR VENDEDOR -->
      <div class="form-field full">
        <label class="form-label">{{ 'relatorio-vendas.labels.selecionar_vendedor' | translate }}</label>
        <p-dropdown [options]="vendedores" [(ngModel)]="selectedVendedor" optionLabel="nome"
          [filter]="true" [filterBy]="'nome,fantasia,telefone,ci,ruc,nomeCidade,codigoPessoa'" [showClear]="true"
          [placeholder]="('relatorio-vendas.labels.selecionar_vendedor' | translate)" (onFilter)="onVendedoresFilter($event)"
          [loading]="loadingVendedores" styleClass="w-full" appendTo="body">

          <ng-template pTemplate="header">
            <div class="grid font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="col-2">{{ 'relatorio-vendas.table_headers.codigo' | translate }}</div>
              <div class="col-2">{{ 'relatorio-vendas.table_headers.nome' | translate }}</div>
              <div class="col-2">{{ 'relatorio-vendas.table_headers.nome_fantasia' | translate }}</div>
              <div class="col-2">{{ 'relatorio-vendas.table_headers.telefone' | translate }}</div>
              <div class="col-2">{{ 'relatorio-vendas.table_headers.ci' | translate }}</div>
              <div class="col-2">{{ 'relatorio-vendas.table_headers.ruc' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-vendedor pTemplate="item">
            <div class="grid px-2 py-1 text-sm">
              <div class="col-2">{{ vendedor.codigoPessoa }}</div>
              <div class="col-2">{{ vendedor.nome }}</div>
              <div class="col-2">{{ vendedor.fantasia }}</div>
              <div class="col-2">{{ vendedor.telefone }}</div>
              <div class="col-2">{{ vendedor.ci }}</div>
              <div class="col-2">{{ vendedor.ruc }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-vendas.labels.nenhum_vendedor_encontrado' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- TIMBRADO -->
      <div class="form-field col-6">
        <label class="form-label">{{ 'relatorio-vendas.labels.timbrado' | translate }}</label>
        <p-dropdown [options]="timbradosDeVenda" [(ngModel)]="selectedTimbrado"
          optionLabel="{{formatarNumeroTimbrado(selectedTimbrado)}}" [filter]="true" [filterBy]="'tipoNota?.nome'"
          [showClear]="true" [placeholder]="('relatorio-vendas.placeholders.selecione' | translate)"
          (onFilter)="onTimbradosFilter($event)" [loading]="loadingTimbrados" styleClass="w-full" appendTo="body">

          <ng-template pTemplate="header">
            <div class="grid font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="col-5">{{ 'relatorio-vendas.table_headers.nome' | translate }}</div>
              <div class="col-7">{{ 'relatorio-vendas.table_headers.numero' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-timbrado pTemplate="item">
            <div class="grid px-2 py-1 text-sm">
              <div class="col-5">{{ timbrado.tipoNota?.nome }}</div>
              <div class="col-7">{{ formatarNumeroTimbrado(timbrado) }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="selectedItem" let-timbrado>
            {{ timbrado.tipoNota?.nome + (timbrado.id != null ? ' - ' + formatarNumeroTimbrado(timbrado) : '') }}
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-vendas.labels.nenhum_cliente_encontrado' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Selecionar Período (componente compartilhado do dashboard) -->
      <div class="form-field col-4">
        <label class="form-label">{{ 'periodos_relatorio.selecione_o_periodo' | translate }}</label>
        <app-periodo-filtro modo="avancado" [valorPadrao]="'showAll'" [persistir]="true" [opcoes]="opcoesPeriodo" [textoExibicao]="periodoTexto"
          styleClass="w-full periodo-filtro-neutro" (periodoChanged)="onPeriodoChanged($event)"></app-periodo-filtro>
      </div>

      <!-- ITENS DETALHADOS -->
      <div class="form-field full">
        <label class="form-label">{{ 'relatorio-vendas.labels.detalhes' | translate }}</label>
        <div class="checkbox-group">
          <div class="checkbox-item">
            <p-checkbox name="exibirFormaPagamentoDetalhada" [(ngModel)]="params.exibirFormaPagamentoDetalhada"
              binary="true" inputId="pagamentoDetalhado">
            </p-checkbox>
            <label for="pagamentoDetalhado">
              {{ 'relatorio-vendas.labels.mostrar_forma_de_pagamento_detalhada' | translate }}
            </label>
          </div>
        </div>
      </div>

      <!-- CANCELADO -->
      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-vendas.labels.cancelado' | translate }}</label>
        <div class="radio-group">
          <div class="radio-item">
            <p-radioButton name="cancelado" [value]="undefined" [(ngModel)]="params.cancelado" inputId="canceladoTodos">
            </p-radioButton>
            <label for="canceladoTodos">{{ 'relatorio-vendas.labels.todos' | translate }}</label>
          </div>
          <div class="radio-item">
            <p-radioButton name="cancelado" [value]="true" [(ngModel)]="params.cancelado" inputId="canceladoSim">
            </p-radioButton>
            <label for="canceladoSim">{{ 'relatorio-vendas.labels.sim' | translate }}</label>
          </div>
          <div class="radio-item">
            <p-radioButton name="cancelado" [value]="false" [(ngModel)]="params.cancelado" inputId="canceladoNao">
            </p-radioButton>
            <label for="canceladoNao">{{ 'relatorio-vendas.labels.nao' | translate }}</label>
          </div>
        </div>
      </div>

      <!-- FATURA LEGAL -->
      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-vendas.labels.fatura_legal' | translate }}</label>
        <div class="radio-group">
          <div class="radio-item">
            <p-radioButton name="ehFaturaLegal" [value]="undefined" [(ngModel)]="params.ehFaturaLegal"
              inputId="faturaTodos">
            </p-radioButton>
            <label for="faturaTodos">{{ 'relatorio-vendas.labels.todos' | translate }}</label>
          </div>
          <div class="radio-item">
            <p-radioButton name="ehFaturaLegal" [value]="true" [(ngModel)]="params.ehFaturaLegal" inputId="faturaSim">
            </p-radioButton>
            <label for="faturaSim">{{ 'relatorio-vendas.labels.sim' | translate }}</label>
          </div>
          <div class="radio-item">
            <p-radioButton name="ehFaturaLegal" [value]="false" [(ngModel)]="params.ehFaturaLegal" inputId="faturaNao">
            </p-radioButton>
            <label for="faturaNao">{{ 'relatorio-vendas.labels.nao' | translate }}</label>
          </div>
        </div>
      </div>

      <!-- MOSTRAR MERCADORIAS -->
      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-vendas.labels.mostrar_mercadorias' | translate }}</label>
        <div class="radio-group">
          <div class="radio-item">
            <p-radioButton name="exibirMercadorias" [value]="true" [(ngModel)]="params.exibirMercadorias"
              inputId="exibirMercadoriasSim">
            </p-radioButton>
            <label for="exibirMercadoriasSim">{{ 'relatorio-vendas.labels.sim' | translate }}</label>
          </div>
          <div class="radio-item">
            <p-radioButton name="exibirMercadorias" [value]="false" [(ngModel)]="params.exibirMercadorias"
              inputId="exibirMercadoriasNao">
            </p-radioButton>
            <label for="exibirMercadoriasNao">{{ 'relatorio-vendas.labels.nao' | translate }}</label>
          </div>
        </div>
      </div>

      <!-- MOSTRAR MERCADORIAS RESUMIDA -->
      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-vendas.labels.mostrar_mercadorias_resumida' | translate }}</label>
        <div class="radio-group">
          <div class="radio-item">
            <p-radioButton name="exibirMercadoriasResumida" [value]="true" [(ngModel)]="params.exibirMercadoriasResumida"
              inputId="exibirMercadoriasResumidaSim">
            </p-radioButton>
            <label for="exibirMercadoriasResumidaSim">{{ 'relatorio-vendas.labels.sim' | translate }}</label>
          </div>
          <div class="radio-item">
            <p-radioButton name="exibirMercadoriasResumida" [value]="false" [(ngModel)]="params.exibirMercadoriasResumida"
              inputId="exibirMercadoriasResumidaNao">
            </p-radioButton>
            <label for="exibirMercadoriasResumidaNao">{{ 'relatorio-vendas.labels.nao' | translate }}</label>
          </div>
        </div>
      </div>

      <!-- MOSTRAR RESUMO DO METODO DE PAGAMENTO -->
      <div class="form-field third">
        <label class="form-label">{{ 'relatorio-vendas.labels.mostrar_resumo_metodo_pagamento' | translate }}</label>
        <div class="radio-group">
          <div class="radio-item">
            <p-radioButton name="exibirFormaDePagamentoResumida" [value]="true"
              [(ngModel)]="params.exibirFormaDePagamentoResumida" inputId="resumoPagSim">
            </p-radioButton>
            <label for="resumoPagSim">{{ 'relatorio-vendas.labels.sim' | translate }}</label>
          </div>
          <div class="radio-item">
            <p-radioButton name="exibirFormaDePagamentoResumida" [value]="false"
              [(ngModel)]="params.exibirFormaDePagamentoResumida" inputId="resumoPagNao">
            </p-radioButton>
            <label for="resumoPagNao">{{ 'relatorio-vendas.labels.nao' | translate }}</label>
          </div>
        </div>
      </div>

      <!-- BOTÃO EMITIR -->
      <div class="form-field full">
        <div class="actions-container">
          <button pButton type="button" [disabled]="emitindoRelatorio" class="btn-primary"
            label="{{ 'relatorio-vendas.buttons.emitir_relatorio' | translate }}" icon="pi pi-file-pdf"
            (click)="emitirRelatorio()">
          </button>
          <app-loading-dialog [visible]="emitindoRelatorio"
            title="{{ 'relatorios.texts.gerando_relatorio' | translate }}" />
        </div>
      </div>

    </div>
  </div>
</div>

<p-toast></p-toast>
